import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import request from "./request";

//region 类型定义

export var PriorityEnum;
(function (PriorityEnum) {
  PriorityEnum[PriorityEnum["LOW"] = 0] = "LOW";
  PriorityEnum[PriorityEnum["Mid"] = 5] = "Mid";
  PriorityEnum[PriorityEnum["HIGH"] = 10] = "HIGH";
})(PriorityEnum || (PriorityEnum = {}));
export var StatusEnum; //已读
//列表查询
(function (StatusEnum) {
  StatusEnum[StatusEnum["UNREAD"] = 0] = "UNREAD";
  StatusEnum[StatusEnum["READ"] = 1] = "READ";
})(StatusEnum || (StatusEnum = {}));
//endregion

//查询消息列表
export var queryList = function queryList(params, ittConfig) {
  return request(_objectSpread({
    url: '/message/ims/notifications',
    method: 'GET',
    params: params
  }, ittConfig));
};

//消息批量已读/未读
export var transReadUnreadMsg = function transReadUnreadMsg(params, ittConfig) {
  return request(_objectSpread({
    url: "/message/ims/notifications/batch/readOrUnread",
    method: 'PUT',
    params: params
  }, ittConfig));
};

//查询已读未读数量
export var queryReadUnreadCount = function queryReadUnreadCount(params, ittConfig) {
  return request(_objectSpread({
    url: "/message/ims/notifications/stats",
    method: 'GET',
    params: params
  }, ittConfig));
};